import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import interceptors from './plugins/interceptors'
import router from './router'
import store from './store'
import dataConversion from './utils/dataConversion'
import perFunctions from './utils/perFunctions'
import perServices from './utils/perServices'
import errorHandle from './utils/errorHandle'
import g2eVueOauth from '../node_modules/g2e-vue-oauth/src/libs/g2eVueOauth/index'
import siteIntegrate from '@/api/general/siteIntegrate'
import moment from 'moment'
import config from '@/config/config.js'
import { PUBLIC_PATH, DEVICE_TYPE_CODE } from './constant/constant'
// import clientLogApi from './api/general/clientLog'
// import { globalModule } from './store/moduleName'

import './css/style.css'
import './css/vuetify_override.css'
import i18n from './i18n'

let isProd = process.env.NODE_ENV === 'production'
let isWeb = process.env.VUE_APP_MODE === 'WEB'
// let isApp = process.env.VUE_APP_MODE === 'APP'
// let isPwa = process.env.VUE_APP_MODE === 'PWA'

Vue.config.productionTip = false

Vue.use(errorHandle)

Vue.use(g2eVueOauth, {
  loginURL: (isProd && isWeb) ? siteIntegrate.getG2ePortalSignInUrl() : '',
  // loginHandlePath: isPwa ? 'login' : '', // Login file is not exist in this project, it is only used to by pass the OAuth checking
  logoutURL: isWeb ? siteIntegrate.getG2ePortalSignInUrl() : PUBLIC_PATH + '/accessDeny',
  clientId: 'IPCDrxrNT1iXg9QbrLsmQV8PxSGQoSE2pThw06bt', // production
  oauthServer: 'https://entity-account.safp.gov.mo', // production
  isHistoryMode: true, // optional, default is false
  // isApp: isApp,
  rootPath: PUBLIC_PATH,
  deviceTypeCode: DEVICE_TYPE_CODE,
  accessDenyPage: PUBLIC_PATH + '/accessDeny',
  apiDomain: config.apiDomain.ALI
  // clientId: 'f4zyBMwOyS592J3bDhhp0LvU30L4DG9jc8LvvDR6', // UAT
  // oauthServer: 'https://account-dev.informac.gov.mo' // UAT
})

// for data conversion like chinDesc/portDesc
Vue.use(dataConversion)

// for perFunctions control
Vue.use(perFunctions)

// For perServices control
Vue.use(perServices)

// config for LOCAL, UAT, PROD
Vue.prototype.$config = config

moment.locale(['zh-hk', 'pt'])

// axios interceptors
interceptors.setup()

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
